import { renderToString } from "react-dom/server";

import { constants, getChannelValue } from "app/components/React/MarketingChannelsDistribution/constants";
import {
    Text,
    MarketingChannelsDistributionContainer,
} from "app/components/React/MarketingChannelsDistribution/styledComponents";
import { percentageSignFilter } from "app/filters/ngFilters";
import I18n from "pro-features/components/WithTranslation/src/I18n";

export const MarketingChannelsDistributionSingle = (props) => {
    const { marketingChannelsDistributionData, marketingChannelsType } = props;
    const { SINGLE_MODE_KEY: titleKey, API_RESULTS_NAME: apiResultsName } = constants[marketingChannelsType];
    const marketingChannelsDistributionDataValues = Object.values(marketingChannelsDistributionData)[0] as Record<
        string,
        number
    >;
    const totalAmount = Object.values(marketingChannelsDistributionDataValues).reduce(
        (sum, current) => sum + current,
        0,
    );
    const currentChannelAmount = getChannelValue(marketingChannelsDistributionDataValues, apiResultsName);
    const currentChannelRelativeShare = currentChannelAmount / totalAmount;
    const ONE_PERCENT = 1 / 100;
    const LESS_THEN_ONE_PERCENT_DISPLAY_VALUE = "<1%";
    const currentChannelRelativeShareToDisplay =
        currentChannelRelativeShare < ONE_PERCENT
            ? LESS_THEN_ONE_PERCENT_DISPLAY_VALUE
            : percentageSignFilter()(currentChannelRelativeShare, 2);
    const replacementObject = {
        percentageAmount: renderToString(<strong>{currentChannelRelativeShareToDisplay}</strong>),
    };

    return (
        <MarketingChannelsDistributionContainer>
            <Text>
                <I18n
                    dangerouslySetInnerHTML={true}
                    dataObj={replacementObject}
                >
                    {titleKey}
                </I18n>
            </Text>
        </MarketingChannelsDistributionContainer>
    );
};
